/**
 * Canonical `resourceType` / `parentResourceType` values persisted on uploaded blobs
 * (FileEntity.RelatedObjectType / ParentObjectType on the backend).
 *
 * The names mirror the C# entity/table names. Most match the vocabulary the data-migration tool
 * (VChainer.Tools.BlobImport) writes, so migrated and newly-created blobs stay consistent; a few
 * (DocumentReference, MaterialCard) are forward-looking domains the importer's resolver does not yet
 * cover — extend CompanyResolver.cs to match if their prod blobs turn up unresolved at import time.
 *
 * Note: these are descriptive metadata only — the backend scopes blob reads by companyId + resourceId,
 * not by type. Setting them does not affect lookups; it keeps the Files table self-describing.
 */
export const BlobResourceType = {
    Document: "Document",
    Project: "Project",
    ProjectProcess: "ProjectProcess",
    BusinessCase: "BusinessCase",
    Device: "Device",
    DeviceSpecification: "DeviceSpecification", // both FS and DS specs (same table, Type discriminator)
    CompanyProfile: "CompanyProfile",
    SupplierDevice: "SupplierDevice",
    MeetingMinutes: "MeetingMinutes",
    UrsOffer: "UrsOffer",
    UrsRequirement: "UrsRequirement",
    UrsOfferRequirement: "UrsOfferRequirement",
    UrsOfferMessage: "UrsOfferMessage",
    DocumentReference: "DocumentReference", // owned by a Document (parent = owning Document guid); not yet in the migration resolver
    MaterialCard: "MaterialCard", // no entity-level company link (scoped only by the uploader's JWT company); no parent
} as const

export type BlobResourceType = typeof BlobResourceType[keyof typeof BlobResourceType]
